import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatApiErrorMessage } from '../../utils';
import { apiEndpoints } from '../../constants';
import { notificationAlert } from '../notifications';
import { unsignedStatementsStoreKey } from './unsignedStatements.const';

export const generateUnsignedStatements = createAsyncThunk(
  `${unsignedStatementsStoreKey}/generateUnsignedStatements`,
  async (body: any, thunkAPI) => {
    try {
      const response = await axios.post(
        apiEndpoints.generateUnsignedFinStatement(),
        body,
      );
      thunkAPI.dispatch(
        notificationAlert('Generating unsigned statements', {
          variant: 'success',
        }),
      );
      return response.data;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(formatApiErrorMessage(err), {
          variant: 'error',
          persist: true,
        }),
      );
      throw new Error(err);
    }
  },
);
